import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — carpet tile. Same 1x1 m / 0.06-thick slab convention as
// floor-wood; a slightly darker thin border is inset on the top surface.
const CARPET = "#8a95a0";
const CARPET_DARK = "#77828e";

export const floorCarpet = defineModel({
  id: "floor-carpet",
  batchId: "modern",
  name: "Carpet floor",
  tags: ["modern", "interior", "structure", "floor", "carpet"],
  summary: "A 1x1 dusty blue-grey carpet tile with a darker inset border.",
  description:
    "A one-tile carpet slab of the Modern Living kit: exactly 1x1 m and " +
    "0.06 m thick, dusty blue-grey with a slightly darker thin border inset " +
    "on top. Tiles seamlessly against every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    // Border frame: four thin strips inset 0.08 from the tile edges.
    const inset = 0.08;
    const strip = 0.03;
    const mid = 0.5 - inset - strip / 2; // centre offset of each border strip
    const len = 1.0 - 2 * inset; // outer length of the frame
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: CARPET, position: [0, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(len, 0.012, strip), color: CARPET_DARK, position: [0, 0.06, -mid] },
      { geometry: new THREE.BoxGeometry(len, 0.012, strip), color: CARPET_DARK, position: [0, 0.06, mid] },
      { geometry: new THREE.BoxGeometry(strip, 0.012, len - 2 * strip), color: CARPET_DARK, position: [-mid, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(strip, 0.012, len - 2 * strip), color: CARPET_DARK, position: [mid, 0.06, 0] },
    ];
  },
  animations: [],
});
